<template>
  <div class="page_container">
      <pageHeader :hasBack="true" v-if="$route.name!=='index'&&$route.name!='userCenter'"></pageHeader>
      <router-view></router-view>
  </div>
</template>

<script>
import pageHeader from '@/components/header'
export default {
  name: 'app',
  components: {pageHeader},
  data(){
      return {};
  }
}
</script>



// WEBPACK FOOTER //
// src/page/main.vue